<template>
  <div class='apply_bg'>
    <h2 class="page-title" v-if="currentScreen === 'agreement'">月票申辦</h2>
    <p class="title-description" v-if="currentScreen === 'agreement'">請詳閱相關條款內容後，再進行申請步驟</p>
    <div v-if="currentScreen === 'agreement'" class="apply-container">
      <div class="content">
 
        <div class="agreement-scroll-container" ref="agreementContainer" @scroll="handleScroll">
          <h3>台灣聯通-月票申請書條約內容</h3>
          <p class="left-align">立約人：甲方：台灣聯通停車場開發股份有限公司</p>
          <p class="left-align">乙方：申請人</p>
          <p class="left-align">台灣聯通-月票申請書條約內容</p>
          <p class="left-align">立約人：甲方：台灣聯通停車場開發股份有限公司 乙方：申請人</p>
          <p class="left-align">就停車場月票購買使用事宜，甲乙雙方約定遵守下列各條款（下稱本契約）：</p>
          <p class="left-align">
            1.乙方於本契約生效時，除應支付月票期間之停車費用外，另應繳付甲方一個月之月票金額(當月公告價格)，作為乙方履約保證金；甲方保有調整月票金額之權利，甲方如有調整月票金額者，應於預定調整日前30日通知乙方，乙方如有異議，應於收到甲方調整通知後7日內通知甲方，否則視同乙方同意該調整之約定。乙方如不同意前述調整者，甲方得終止乙方月票資格並終止本契約。
          </p>
          <p class="left-align">2.凡甲方收取之所有款項，均有甲方之收據或發票，為確保您的權益，請記得索取並妥善保管。</p>
          <p class="left-align">3.購置停車月票卡之乙方，如停車月票卡、磁卡或遙控器遺失、毀損或變形，可攜帶相關證件至本停車場辦理遺失補發，並繳交磁卡工本費：新臺幣500元或遙控器工本費：新臺幣1000元。
          </p>
          <p class="left-align">4.乙方需停放於約定之停車場、區域或樓層，未按規定停放，甲方將按日該場臨停費率收取停車費，並有權隨時終止乙方月票資格及本契約。</p>
          <p class="left-align">
            5.乙方應填寫正確基本資料，以便甲方提供相關訊息，確保乙方的權益。乙方通訊方式變更若未依規定通知甲方，致使錯失重要訊息或喪失權益者，概由乙方自行負責。乙方不得據此請求損害賠償，絕無異議。</p>
          <p class="left-align">6.繳費期間：乙方請於到期日前繳納次一期月票金額，如逾期未繳納而續停，則按該場臨停費率計算，並取消月票資格，且臨停發票恕不退費。</p>
          <p class="left-align">7.購買月票限原登記車號使用，乙方不得私自轉讓、出借、出租予其他人使用。變更車號如未事先告知，入場後需以臨停費率計算離場，且不得事後申請退費。</p>
          <p class="left-align">8.優惠停車採季票方式者，使用期間，未停放之月份，不得要求保留或順延至下一季。確認不使用，依終止契約方式辦理。</p>
          <p class="left-align">9.任一方擬提前終止合約，應於月票到期前通知他方，乙方需填具相關表格以利甲方將未到期之預付款，依退票方式處理，無息退還予乙方。</p>
          <!-- <p class="left-align">10.乙方對期限內未使用完之停車月票卡，得依實際未使用天數比例申請退費。甲方於受理退費時，得酌收手續費(新台幣500元整)。</p> -->
          <p class="left-align">10.乙方對期限內未使用完或尚未啟用之停車月票，得依實際未使用天數比例申請退費。甲方於受理退費時，得酌收手續費(新台幣500元整)。</p> 
          <p class="left-align">
            11.月票、保證金之退回：乙方若於當月15日前辦理退票者，應退款項可於當月底取得，若於16日後辦理退票者，應退款項將於次月底取得；均以網路匯款方式退回保證金。上述款項之退回，需辦完相關手續並繳交回磁卡、遙控器等應返還物品，才能進行退款程序。
          </p>
          <p class="left-align">12.乙方辦理退票時，所提供之退款帳戶戶名須與乙方申辦時所登記之姓名相符，恕不接受提供第三人帳戶辦理退款。</p>
          <p class="left-align">13.持有月票磁卡者，請務必攜帶磁卡，以免影響停車權益。</p>
          <p class="left-align">14.月票購買者，請依序排隊入場，停車場不保留車位，請自行考量後購買。</p>
          <p class="left-align">15.本停車場僅提供車輛停放之用，不負保管責任。但可歸責於甲方之事由，致車輛毀損、滅失或車內物品遺失者，不在此限。</p>
          <p class="left-align">
            16.車輛進、出場應遵循停車場內標誌、標線或依管理人員指示方向進出，車輛停放時，應依標誌、標線、停車格位佈設方式入格停妥車輛，俾確保安全，如有任意停放致妨礙其他車輛行進或停放者，甲方得依停車場法第三十二條規定，將車輛移置至適當處所，並得請求移置費(按實際支出違規拖吊費用計算)，如因違規停放導致停車場內意外事故或損壞相關停車設施，乙方應負損害賠償責任。
          </p>
          <p class="left-align">
            17.月票期限內，甲方如因所有權人需要收回使用或因政府法令限制規定無法繼續本業務時，得隨時通知乙方，乙方同意配合提前終止本契約，且不得要求甲方為其他任何給付或賠償，甲方將按日返還未到期費用。</p>
          <p class="left-align">
            18.契約結束或終止翌日，乙方如未遷讓返還停車位予甲方，甲方除得取消月票停車磁卡進出停車場之權利外，並得向乙方請求按照月票二倍計算之違約金，前述違約金得以履約保證金扣抵之，乙方絕無異議。</p>
          <p class="left-align">
            19.乙方車輛停放於停車場內逾期超過30日以上未駛離，甲方得通知車主限期補繳停車費，逾期未補繳者，甲方得逕行終止乙方月票資格及終止本契約，並得逕行將乙方車輛移置他處、對乙方車輛行使民法第445條之留置權（處分車輛取償）或為其他一切之合法措施。
          </p>
          <p class="left-align">20.於中央氣象局或其他主管機關發布豪雨或陸上颱風警報時，乙方應將車輛駛離甲方停車場，以免受到不可抗力之災害，而發生損害時，由乙方自行負責，甲方不負任何賠償責任。</p>
          <p class="left-align">21.天災發生時（包括颱風、洪水、地震…等），如各級縣市政府宣佈停班，甲方將採取足以保障勞工安全之必要措施，部分停車場將無法提供車輛進、出場之服務，乙方如有用車之需求，請提早將車輛駛離甲方停車場，且不得要求甲方為其他任何給付或賠償。</p>
          <p class="left-align">22.乙方如違反上列使用事項，甲方得隨時終止契約。</p>
          <p class="left-align">
            23.乙方同意提供之個人資料，得作為甲方處理本契約及雙方停車租用業務之行政管理、聯繫及履約爭議處理等用途，並確認乙方已明確知悉上開資料之類別、使用目的、範圍、利用之期間、地區、對象及方式、提供前述資料對其權益之影響以及其他個人資料保護法所定之其他應告知之一切事項。如乙方對上開資料有查詢、補充、更正、請求複本、停止蒐集、處理、利用或刪除資料所需求時，得依據個人資料保護法規定洽請甲方處理。
          </p>
          <p class="left-align">24.甲方應設置消費者服務專線電話：(02)2523-5000。</p>
          <p class="left-align">25.基於甲、乙雙方因本契約涉訟時，同意以台灣台北地方法院為第一審管轄法院並以中華民國法律為適用法律。</p>
          <p class="left-align">
            26.乙方購買月票及使用甲方停車場服務時，即視為乙方同意接受甲方月票規定及本契約約定。甲方保有調整甲方月票規定及本契約約定之權利，甲方如有調整甲方月票規定及本契約約定者，應於預定調整日前15日通知乙方，乙方如有異議，應於收到甲方調整通知後7日內通知甲方，否則視同乙方同意該調整之約定。乙方如不同意前述調整約定者，甲方得終止乙方月票資格及終止本契約。
          </p>
          <p class="left-align">27.本契約自乙方簽署月票購買契約之日起生效。</p>
        </div>
      </div>

      <button class="submit-button" @click="goTWApply" :disabled="!hasScrolledToBottom">
        我已閲讀上述條款並同意月票申辦
      </button>
    </div>


  </div>

    <!-- AgreementAccepted Form -->
    <UserApplyForm v-if="currentScreen === 'form'" @formSubmitted="submitApplication" />

    <!-- Success Screen -->
    <SubmissionSuccess v-if="currentScreen === 'success'" @reset="resetApplication" />


  <ContactFooter />
</template>

<script>
import ContactFooter from '@/components/ContactFooter.vue';
import UserApplyForm from "@/views/ticket/UserApplyForm.vue";
import SubmissionSuccess from "@/views/ticket/SubmissionSuccess.vue";
import PullDAO from '@/services/PullDAO';

import { globalParams } from '@/global';

export default {
  name: 'UserApply',
  components: {
    UserApplyForm,
    SubmissionSuccess,

    ContactFooter
  },
  data() {
    return {
      // currentScreen: "agreement", // 当前屏幕状态
      currentScreen: "agreement",
      hasScrolledToBottom: false,
      formDataa: {
        city: "台北市",
        parking_id: 123,
        parking_lot: "停車場A",
        parking_type: "地下停車場",
        time_period: "月租",
        rental_start_date: "2023-10-01",
        car_owner_name: "陳小明",
        lp_number: "ABC-1234",
        contact_phone: "0987654321",
        secondary_contact_phone: "",
        car_owner_email: "",
        invoice_tax_id: "",
        invoice_title: "",
        billing_cycle: "每月",
        // process_status: "待處理",
        // process_comment: "無備註",
      },
      pullDAO: new PullDAO(), // 数据访问对象
    };
  },
  methods: {
    agreeToTerms() {
      this.currentScreen = "form"; // 切换到表单屏幕
    },

    handleScroll(event) {
      const container = event.target;
      // Check if user has scrolled to the bottom (with a small buffer)
      const isAtBottom = container.scrollHeight - container.scrollTop <= container.clientHeight + 5;
      
      if (isAtBottom) {
        this.hasScrolledToBottom = true;
      }
    },

    goTWApply() {
      //goto https://webrent.taiwan-parking.com.tw/WebRentcs/WebRentcs.aspx
      window.open('https://webrent.taiwan-parking.com.tw/WebRentcs/WebRentcs.aspx', '_blank');
    },
    async submitApplication() {
      try {
        this.formDataa = globalParams.ticket_apply_form_data;
        // console.log('Application form data:', globalParams.ticket_apply_form_data);
        // alert(globalParams.ticket_apply_form_data);
        const response = await this.pullDAO.addRentalApply(this.formDataa);

        if (response.success) {
          console.log('Application submitted successfully:', response);

          // 切换到成功屏幕
          this.currentScreen = "success";
        } else {
          console.error('Error submitting application:', response);
          alert('提交失败，原因' + response.message);
        }
      } catch (error) {
        console.error('Error submitting application:', error);
        alert('提交失败，請稍后重试。');
      }
    },
    resetApplication() {
      this.currentScreen = "agreement"; // 重置为协议屏幕
    },
  },
};



</script>

<style scoped>
.apply_bg {
  background-color: var(--background-gray);
  /* padding-bottom: 5rem; */
  width: 100%;
}

.page-title {
  margin-bottom: 16px;
}

.title-description {
  margin-bottom: 40px;
  /* //styleName: xl/regular; */
  font-family: Inter;
  font-size: 20px;
  font-weight: 400;
  line-height: 30px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  color: var(--gray13);

}


.content {
  max-width: 1416px;
  margin: 0px auto;
  /* padding: 72px 48px; */
  padding: 0px;
  background-color: #f9f9f9;
  border-radius: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

  /* padding-bottom: 60px; */

  box-sizing: border-box;
}

.agreement-scroll-container {
  height: 80vh;
  overflow-y: auto;
  border: 1px solid #e0e0e0;
  padding: 0 20px;
  /* margin-bottom: 20px; */
  border-radius: 20px;
  background-color: #ffffff;
}

h3 {
  /* //styleName: 4xl/bold; */
  margin: 0px;
  margin-top:40px;
  margin-bottom: 40px;

  font-family: Inter;
  font-size: 32px;
  font-weight: 700;
  line-height: 43.52px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  color: var(--gray15);
}

p {
  /* //styleName: lg/regular; */
  margin-bottom: 32px;
  font-family: Inter;
  font-size: 18px;
  font-weight: 400;
  line-height: 26.1px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  color: var(--gray15);
}

.left-align {
  text-align: left;
}




.submit-button {

  padding: 24px 40px 24px 40px;
  border-radius: 99px;
  border: none;

  background-color: var(--green03);
  color: white;

  margin-top: 30px;
  margin-bottom: 160px;


  /* //styleName: xl/bold; */
  font-family: Inter;
  font-size: 20px;
  font-weight: 700;
  line-height: 30px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
}

.submit-button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.submit-button:hover:not(:disabled) {
  background-color: #219653;
}

.success-screen {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 50px;
}

.success-box {
  background-color: #fff;
  padding: 40px;
  border-radius: 8px;
  text-align: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.success-icon {
  width: 50px;
  height: 50px;
  margin-bottom: 20px;
}

.success-box h2 {
  color: #008000;
  font-size: 2rem;
  margin-bottom: 10px;
}

.success-box p {
  color: #333;
  font-size: 1rem;
  line-height: 1.5;
  margin-bottom: 20px;
}

.success-button {
  padding: 10px 20px;
  background-color: transparent;
  color: #008000;
  font-weight: bold;
  border: none;
  cursor: pointer;
  text-decoration: underline;
}

/* Responsive Design for small screens */
@media (max-width: 560px) {

  .page-title {
    /* font-size: 1.5rem; */
    margin-bottom: 8px;
  }

  .title-description {

    margin-top: 8px;

    margin-bottom: 10px;

    /* //styleName: sm/regular; */
    font-family: Inter;
    font-size: 14px;
    font-weight: 400;
    line-height: 21.56px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;


  }

  .content {
    /* padding: 40px; */
    max-width: 343px;
    /* padding: 24px 21px; */

    /* padding-bottom: 12px; */
    margin-bottom: 0px;

  }



  h3 {
    /* //styleName: lg/bold; */
    font-family: Inter;
    font-size: 18px;
    font-weight: 700;
    line-height: 26.1px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;

    margin-bottom: 22px;

  }


  p {
    font-family: Inter;
    font-size: 12px;
    font-weight: 400;
    line-height: 18.48px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;

    margin-bottom: 20px;

  }

  .submit-button {
    padding: 10px 20px 10px 20px;
    border-radius: 99px;

    /* //styleName: sm/bold; */
    font-family: Inter;
    font-size: 14px;
    font-weight: 700;
    line-height: 21.56px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;

    margin-top: 16px;
    margin-bottom: 64px;
    
  }

  .agreement-scroll-container {
    height: 80vh;

    padding: 0 10px;
  }

}
</style>
